<template>
  <div>
    <tool-bar :title="title"></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity">
    </activity-redirect-item>

    <refresh-item :show="showRefreshItem" @onRefresh="fetchAgentPhoneNumber"></refresh-item>

    <stage-comment-item v-if="!showRefreshItem"></stage-comment-item>

    <div v-if="showUI && !showRefreshItem">
      <div class="input_container">
        <weex-text class="input_label">Please enter mobile number of the agent</weex-text>
        <div class="item-phone-number-input-container margin-top-5">
          <phone-code-item></phone-code-item>
          <input
            class="item-phone-number-input"
            :value="agentPhoneNumber"
            maxlength="10"
            @input="onAgentPhoneNumberEntered($event.target.value)"
            type="number" />
        </div>
      </div>

      <div v-if="otpSent" class="input_container">
        <weex-text class="input_label">OTP</weex-text>
        <input
          class="input_with_border_bottom"
          type="number"
          maxlength="6"
          :value="otp"
          @input="otp=$event.target.value">

        <div class="margin-top-10">
          <weex-text>
            <span class="font-size-sm text-color-gray">Did not receive OTP?</span>
            <span
              v-if="!countdownCompleted"
              class="font-size-sm text-color-gray">&nbsp;Resend OTP in
            </span>
            <span
              v-if="!countdownCompleted"
              class="font-size-sm text-color-gray">{{countdownRemainingSeconds}} second(s).
            </span>
            <span
              @click="onSendOrResendOTPClicked"
              v-if="countdownCompleted"
              class="item-sm-link">Click here
            </span>
            <span
              v-if="countdownCompleted"
              class="font-size-sm text-color-gray">to resend OTP.
            </span>
          </weex-text>
          <wxc-countdown
            v-if="!countdownCompleted"
            v-show="false"
            tpl="{s}"
            :time="countDowntime"
            @wxcOnComplete="onCountdownCompleted"
            @countdownDetails="countdownDetails"
          ></wxc-countdown>
        </div>
      </div>

      <wxc-button
        v-if="!otpSent"
        text="Send OTP"
        class="horizontal_center margin-top-30"
        type="blue"
        @wxcButtonClicked="onSendOrResendOTPClicked">
      </wxc-button>

      <wxc-button
        v-if="otpSent"
        text="Submit OTP"
        class="button_horizontal_center margin_top_20 margin-bottom-20"
        type="blue"
        @wxcButtonClicked="onSubmitOTPClicked">
      </wxc-button>

    </div>

  </div>
</template>

<script>
import ToolBar from "../layout/ToolBar";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import PhoneCodeItem from "../layout/PhoneCodeItem";
import Loading from "../layout/Loading";
import StageCommentItem from "../layout/StageCommentItem";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcCountdown from "../../../weex-ui/packages/wxc-countdown/index";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import AlertService from "../core/alert/AlertService";
import { Activities } from "../../utils/ActivityNavigator";
import EzUtils from "../../utils/EzUtils";
import { MessageConstants } from "../../utils/MessageConstantUtil";
import RefreshItem from "../layout/RefreshItem";
import DataSource from "../../data/DataSource";
import { DataTables } from "../../utils/DataTables";
import { SmsTypes } from "../../utils/SmsTypesConstants";
import AttributeUtil from "../../utils/AttributeUtil";
import { EntityType } from "../../utils/EntityType";
import DateUtils, { DateFormats } from "../../utils/DateUtils";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";

const RESEND_OTP_TIME = 30 * 1000; //30 seconds
const KYC_OTP_VERIFIED_TIMESTAMP_KEY = "kyc.otp.verified.timestamp";
const KYC_OTP_VERIFIED_TIMESTAMP_NAME = "KYC OTP Verified Timestamp";

export default {
  name: "KycOtpActivity",
  components: {
    ToolBar,
    WxcButton,
    WxcCountdown,
    ActivityRedirectItem,
    ErrorAlertItem,
    Loading,
    StageCommentItem,
    RefreshItem,
    PhoneCodeItem
  },

  data: () => ({
    title: "KYC OTP Verification",
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRefreshItem: false,
    showUI: false,
    agentPhoneNumber: "",
    otp: "",
    otpSent: false,
    countdownCompleted: false,
    countdownRemainingSeconds: "",
    countDowntime: ""
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onAgentPhoneNumberEntered(agentPhoneNumber) {
      this.agentPhoneNumber = agentPhoneNumber;
      this.otpSent = false;
      this.otp = "";
    },

    onSendOrResendOTPClicked() {
      this.otp = "";
      if (EzUtils.validatePhoneNumber(this.agentPhoneNumber)) {
        this.loading = true;
        DataSource.sendOTPWithAuth(this.agentPhoneNumber, SmsTypes.KYC)
          .then(sendOTPRes => {
            this.loading = false;
            if (sendOTPRes.errorOccurred) {
              this.showError(sendOTPRes.data);
            } else {
              this.otpSent = true;
              this.countdownCompleted = false;
              this.countDowntime = new Date().getTime() + RESEND_OTP_TIME;
              this.showToast(MessageConstants.OTP_SENT_MESSAGE);
            }
          })
      } else {
        this.showToast(MessageConstants.INVALID_PHONE_NUMBER_MESSAGE);
      }
    },

    onSubmitOTPClicked() {
      if (EzUtils.containsOnlyNumbers(this.otp)) {
        this.loading = true;
        DataSource.verifyOTP(this.agentPhoneNumber, this.otp)
          .then(verifyOTPRes => {
            this.loading = false;
            if (verifyOTPRes.errorOccurred) {
              this.showError(verifyOTPRes.data);
            } else {
              this.saveKYCVerifiedTimestampAttribute();
            }
          })
      } else {
        this.showToast(MessageConstants.INVALID_OTP_MESSAGE);
      }
    },

    saveKYCVerifiedTimestampAttribute() {
      this.loading = true;
      DataSource.createOrUpdateAttribute(
        AttributeUtil.getAttributeUpdateDto(
          EntityType.LOANS,
          LoanScopeDataHolder.getLoanId(),
          AttributeUtil.getSingleAttributeData(
            KYC_OTP_VERIFIED_TIMESTAMP_KEY,
            KYC_OTP_VERIFIED_TIMESTAMP_NAME,
            DateUtils.getCurrentTimeAsFormat(DateFormats.YYYY_MM_DD__HH_mm_ss_SSS)
          )
        )
      )
        .then(attributeRes => {
          if (attributeRes.errorOccurred) {
            this.showError(attributeRes.data);
          } else {
            this.saveAgentPhoneNumber();
          }
        })
    },

    saveAgentPhoneNumber() {
      this.loading = true;
      DataSource.updateDataTableEntry(
        DataTables.LOAN_DETAILS,
        LoanScopeDataHolder.getLoanId(),
        { agent_mobile: this.agentPhoneNumber }
      )
        .then(agentPhoneNumberSaveRes => {
          if (agentPhoneNumberSaveRes.errorOccurred) {
            this.showError(agentPhoneNumberSaveRes.data);
          } else {
            this.completeCurrentTaskAndGetNextTask();
          }
        });
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    },

    onCountdownCompleted() {
      this.countdownCompleted = true;
    },

    countdownDetails(countdownData) {
      this.countdownRemainingSeconds = countdownData.second;
    },

    fetchAgentPhoneNumber() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getDataTableInfo(DataTables.LOAN_DETAILS, LoanScopeDataHolder.getLoanId())
        .then(dataTableRes => {
          this.loading = false;
          if (dataTableRes.errorOccurred) {
            this.showError(dataTableRes.data);
            this.showRefreshItem = true;
          } else {
            const loanDetails = dataTableRes.data;
            if (loanDetails && loanDetails.length > 0 && loanDetails[0].agent_mobile) {
              this.agentPhoneNumber = loanDetails[0].agent_mobile;
            }
            this.showUI = true;
          }
        })
    }
  },

  created() {
    this.fetchAgentPhoneNumber();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.KYC_OTP];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

